module.exports = __webpack_public_path__ + "static/media/login-x-mark.96d5cf7e.svg";